import React, { PropTypes, Component } from 'react';

/**
 * Features section from project settings.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const Features = ({ canEdit, project, features, toggleModal }) => {
  return (
    <div className="sidebar-container">
      <h3>Features</h3>

      <h4>{project.package_name} Package</h4>
      <table className="table table-features">
        <tbody>
          {features.map((f, i) => (
            <tr className={f.active? "active":""} key={i}>
              <td>{f.active && <i className="fa fa-check"></i>}</td>
              <td>{f.name}</td>
            </tr>
          ))}
        </tbody>
      </table>

      { canEdit &&
      <button type="button" onClick={toggleModal} className="btn btn-secondary btn-md">
        Upgrade
      </button>}

  </div>);
}

/**
 * PropTypes.
 *
 * @property {object} project - project
 * @property {bool} canEdit - whether features can be edited
 * @property {array} features - list of features to be listed
 * @property {func} toggleModal - toggle modal to upgrade project's features
 */
Features.propTypes = {
  project: PropTypes.object,
  canEdit: PropTypes.bool,
  features: PropTypes.array,
  toggleModal: PropTypes.func,
};

export default Features;



// WEBPACK FOOTER //
// ./project/components/features.jsx